module.exports = {
  ENV: 'production',
  WEB: process.env.VUE_APP_WEB,
  API_BASE: '',
  DEPLOY: {
    name: '正式',
    //host: '121.224.78.190',
    host: '10.10.1.149',
    username: 'root',
    //password: 'Vyb123!@',
    password: '123456',
    path_local: 'dist',
    path_admin: '/www/wwwroot/yy.vyb.cn/front_admin',
    path_rj: '/www/wwwroot/yy.vyb.cn/front_rj',
    path_tz: '/www/wwwroot/yy.vyb.cn/front_tz',
    path_pk: '/www/wwwroot/yy.vyb.cn/front_pk',
    path_qy: '/www/wwwroot/yy.vyb.cn/front_qy',
    path_yy: '/www/wwwroot/yy.vyb.cn/front_yy',
    path_cs: '/www/wwwroot/yy.vyb.cn/front_cs',
    path_sy: '/www/wwwroot/yy.vyb.cn/front_sy',
    path_ss: '/www/wwwroot/yy.vyb.cn/front_ss',
    path_xh: '/www/wwwroot/yy.vyb.cn/front_xh',
    path_wj: '/www/wwwroot/yy.vyb.cn/front_wj',
  },
};
